/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//German (Germany)
export default {
  'ai-mate.chat-error-banner.description': 'Ihr Chatverlauf wird bis zu 30 Tage gespeichert.',
  'ai-mate.chat-error-banner.title': 'Neuen Chat beginnen',
  'ai-mate.chat-error.description': 'Versuchen Sie den <btn>Chat neu zu laden</btn>.',
  'ai-mate.chat-error.rate-limited-description':
    'Sie haben die maximale Anzahl Anfragen erreicht. Bitte versuchen Sie es später erneut.',
  'ai-mate.chat-error.rate-limited-title': 'Zu viele Anfragen',
  'ai-mate.chat-error.rovo-inactive-description':
    'Rovo ist auf Ihrer Site scheinbar noch nicht aktiviert. <link>Rovo einrichten</link>',
  'ai-mate.chat-error.rovo-inactive-title': 'Rovo ist inaktiv',
  'ai-mate.chat-error.title': 'Wir sind nicht sicher, was schiefgelaufen ist.',
  'conversation-assistant-button.label': 'Chat',
  'conversation-assistant-button.rovo-chat-label': 'Rovo-Chat',
  'highlight-actions.rovo-chat-custom-prompt.placeholder': 'Fragen Sie AI danach',
  'highlight-actions.rovo-chat-explain-option.text': 'Erklären',
  'highlight-actions.rovo-chat-explain-prompt': 'Erkläre das: {selectedText}',
  'highlight-actions.rovo-chat-more-options.tooltip': 'Chatempfehlungen',
  'highlight-actions.rovo-chat-open-chat.tooltip': 'Chat öffnen',
  'highlight-actions.rovo-chat-summarize-option.text': 'Zusammenfassen',
  'highlight-actions.rovo-chat-summarize-prompt': 'Fasse das zusammen: {selectedText}',
  'highlight-actions.rovo-chat.button-text': 'Chat',
  'horizontal-scroll-container.scroll-left': 'Nach links scrollen',
  'horizontal-scroll-container.scroll-right': 'Nach rechts scrollen',
};
